import React, { Component } from "react"
import { Tab, Tabs } from "react-bootstrap"
import { connect } from 'react-redux';
import { AppState } from '../../../store'
import BaseChecklistConfig from "./BaseChecklistConfig/BaseChecklistConfig";
import BaseReviewChecklistConfig from "./BaseReviewChecklistConfig/BaseReviewChecklistConfig";

import "./HRSettings.css"

interface HRSettingsProps {
    userId: number | string
}

interface HRSettingsState {
    activeKey: string
}

class HRSettings extends Component<HRSettingsProps, HRSettingsState> {

    state = {
        activeKey: "WorkCompChecklistConfig"
    }

    render() {

        let features = JSON.parse(process.env.REACT_APP_HR_ADMIN_TOGGLES || "")

        return (
            <div className="HRSettings main-content col-sm">
                <div className="HRSettingsContent">
                    <Tabs defaultActiveKey={this.state.activeKey} variant={"tabs"}>
                        <Tab eventKey="WorkCompChecklistConfig"
                            title={<div className="HRSettingsContentTab"><span className="material-icons">done</span><p>Configure Work Comp Checklist</p></div>}
                            unmountOnExit={true}>
                            <BaseChecklistConfig
                                userId={this.props.userId}
                            />
                        </Tab>
                        {features.Reviews && <Tab eventKey="ReviewChecklistConfig"
                            title={<div className="HRSettingsContentTab"><span className="material-icons">done</span><p>Configure Review Checklist</p></div>}
                            unmountOnExit={true}>
                            <BaseReviewChecklistConfig
                                userId={this.props.userId}
                            />
                        </Tab>}
                    </Tabs>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    userId: state.user.userId,
})

export default connect(mapStateToProps)(HRSettings)